import React, { useState, useEffect, lazy, Suspense } from "react";
import { useLocation } from "react-router-dom";
import { IoIosSearch, SlArrowLeft } from "../utils/Icons";

// Context
import { useTestContext } from "../context/TestContext";

// imports
import UIWrapper from "../components/UIWrapper";
import NavigationTracker from "../components/NavigationTracker";
import ProductComponent from "../components/ProductComponent";
import PackageProductComponent from "../components/PackageProductComponent";
import ProductFilter from "../components/ProductFilter";
const ProductCard = lazy(() => import("../components/ProductCard"));
const PackageProductCard = lazy(() =>
    import("../components/PackageProductCard")
);

const labsData = {
    "Redcliffe Labs":
        "https://finelabs-images.s3.ap-south-1.amazonaws.com/redcliffe-logo.svg",
    "Agilus Diagnostics":
        "https://finelabs-images.s3.ap-south-1.amazonaws.com/agilus-logo.svg",
    "Pathkind Labs":
        "https://finelabs-images.s3.ap-south-1.amazonaws.com/pathkind-logo.svg",
    "Metropolis Healthcare":
        "https://finelabs-images.s3.ap-south-1.amazonaws.com/metropolis-logo.svg",
    "Dr Lal PathLabs":
        "https://finelabs-images.s3.ap-south-1.amazonaws.com/Dr+Lal+logo.svg",
};

const labPageData = [
    {
        icon: "/assets/stamp-blue-icon.svg",
        title: "NABL Accredited Laboratories",
    },
    { icon: "/assets/india-icon.svg", title: "Home Collection All Over India" },
    { icon: "/assets/mail-icon.svg", title: "Quick Report on Mail" },
];

const aboutLabsData = {
    "Redcliffe Labs": {
        timing: "5 AM to 3 PM",
        charge: "Free for orders over ₹ 999 else, there is a ₹ 150 charge",
        products: "Pathology Tests, Packages",
        center: "Not available",
    },
    "Agilus Diagnostics": {
        timing: "6 AM to 6 PM",
        charge: "Free for orders over ₹ 2000 else, there is a ₹ 100 charge",
        products: "Pathology Tests",
        center: "Available",
    },
    "Pathkind Labs": {
        timing: "7 AM to 4 PM",
        charge: "₹ 100",
        products: "Pathology Tests, Packages, Radiology",
        center: "Available",
    },
    "Metropolis Healthcare": {
        timing: "7 AM to 3 PM",
        charge: "₹ 100",
        products: "Pathology Tests, Packages",
        center: "Not available",
    },
    "Dr Lal PathLabs": {
        timing: "7 AM to 2 PM",
        charge: "₹ 100",
        products: "Pathology Tests, Radiology",
        center: "Available",
    },
};

const productType = [
    { title: "Tests", value: "Pathology Test" },
    { title: "Packages", value: "package" },
];
const productTypeAgilus = [{ title: "Tests", value: "Pathology Test" }];

const productTypePathkind = [
    { title: "Tests", value: "Pathology Test" },
    { title: "Packages", value: "package" },
    { title: "Radiology", value: "Radiology" },
];

const productTypeDrLal = [
    { title: "Tests", value: "Pathology Test" },
    { title: "Radiology", value: "Radiology" },
];

const Labs = () => {
    const location = useLocation();
    const {
        fetchProductsByBrandAndType,
        productsByBrandAndType,
        fetchProductsByBrandAndQuery,
        productsByBrandAndQuery,
        setProductsByBrandAndQuery,
        fetchPopularProducts,
        popularProducts,
        productsToBeSearched,
        handleAddProductsToBeSearched,
        handleRemoveProductsToBeSearched,
        globalSearchQuery,
        productsBySearchQuery,
        setProductsBySearchQuery,
        setGlobalSearchQuery,
        fetchProductsBySearchQuery,
        handleSearchByBrandName
    } = useTestContext();
    const [selectedProductType, setSelectedProductType] =
        useState("Pathology Test");
    const [searchQuery, setSearchQuery] = useState("");
    const [isDebounceDropdown, setIsDebounceDropdown] = useState(false);
    const [isSearched, setIsSearched] = useState(false);

    // Extract the last endpoint from the path
    const lastEndpoint = location.pathname.split("/").filter(Boolean).pop();
    const formattedBrandName = lastEndpoint
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    
    // console.log("Formatted Brand Name:", formattedBrandName);

    const brandPopularData = popularProducts.filter(
        (product) => product.brandName === formattedBrandName
    );
    // console.log("Brand Popular Data:", brandPopularData);

    const radiologyPopularData = brandPopularData.filter(
        (product) => product.productType === "Radiology"
    );

    const popularPathologyTestproducts = brandPopularData.filter(
        (product) => product.productType === "Pathology Test" || product.productType === "test"
    );




    // Scroll to top with smooth behavior when filterData changes (or on initial mount)
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [formattedBrandName]);

    const handleSearchQueryChange = (e) => {
        setProductsBySearchQuery([]);
        setGlobalSearchQuery(e.target.value);
        if (e.target.value.length >= 3){
          fetchProductsBySearchQuery(e.target.value)
        }
      };
    
      const handleSearchClick = async() => {
        if (productsToBeSearched.length >= 1) {
            // Join the products with $ separator
            const productsQueryParam = productsToBeSearched.join('$');
            
            // Get current URL and base path
            const currentPath = window.location.pathname;
            
            // Create new URL with products query parameter
            const newUrl = `${currentPath}?products=${encodeURIComponent(productsQueryParam)}`;
            
            // Update the URL without reloading the page
            window.history.pushState({}, '', newUrl);
            
            // Optionally perform other search-related actions here
            // Such as fetching data based on the selected products
            await handleSearchByBrandName(formattedBrandName,productsToBeSearched)
            setIsSearched(true)
        }
    }


    useEffect(() => {
        fetchProductsByBrandAndType(formattedBrandName, selectedProductType);
    }, [formattedBrandName, selectedProductType]);

    useEffect(() => {
        fetchPopularProducts();
    }, []);

    return (
        <UIWrapper searchVisible={false}>
            <ProductFilter />
            <div className="w-full h-fit">
                <div className="w-full h-fit px-[3%] py-2 lg:px-[2%] lg:py-[2%]">
                    {isSearched ? (
                        <div className="w-full h-fit flex justify-start items-center space-x-[2%] lg:space-x-[0.5%] mb-[5%] lg:mb-[1%]">
                            <SlArrowLeft className="font-normal text-[3.5vw] lg:text-[0.75vw] text-textSecondaryColor mb-0.5" />
                            <button
                                className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor hover:underline"
                                onClick={() => setIsSearched(false)}>
                                Back
                            </button>
                        </div>
                    ) : (
                        <NavigationTracker endpoint={formattedBrandName} />
                    )}
                </div>
                <div className="w-full h-fit flex flex-col justify-center items-center mb-[5%] lg:mb-[2%]">
                    <img
                        src={labsData[formattedBrandName]}
                        alt="brand-img"
                        className="mb-[1%] w-[120px] h-[120px]"

                    />
                    <span className="font-semibold text-[5vw] lg:text-[1.5vw] text-textPrimaryColor mb-[0.5%]">
                        {formattedBrandName}
                    </span>
                    <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor text-center">
                        Search from wide range of pathology lab tests and
                        packages.
                    </p>
                </div>
                <div className="flex justify-center">
                <div className="w-[95%] lg:w-[50%] h-[56px] bg-whiteColor flex justify-between items-center rounded-[48px] border-2 border-blue-300 relative">
                <div className="flex w-full flex items-center ml-[2%] overflow-y-scroll" >
                {productsToBeSearched.length == 0 && (<IoIosSearch className="text-xl text-blue-300 mr-[2%]" />)}
                {productsToBeSearched.length > 0 && (
                    <div className={`w-fit h-12 gap-y-2 gap-x-2 ${productsToBeSearched.length == 1 ? 'grid grid-cols-1': 'grid grid-cols-2'} pt-2  mr-2`}>
                    {productsToBeSearched.map((product, index) => (
                        <div key={index} className="w-full px-2 h-[28px] rounded-[28px] bg-[#E0E0E0] flex justify-between items-center mr-2 text-[13px] text-[#57636C]">
                        <div className="w-fit truncate">
                            {product}
                        </div>
                            <img
                            src="/assets/close-icon.svg"
                            alt="close-icon"
                            className="cursor-pointer ml-1 flex-shrink-0"
                            onClick={() => handleRemoveProductsToBeSearched(product)}
                            />
                        </div>
                    ))}
                    </div>
                )}
                
                    <input
                    type="text"
                    value={globalSearchQuery}
                    onChange={handleSearchQueryChange}
                    placeholder="Search from 12,000+ Lab Tests, Packages, X-rays & Scans"
                    className={`${productsToBeSearched.length > 0?'w-[50%]':'w-[92.5%]'} h-full py-1 rounded-xl font-normal text-[14px] text-textPrimaryColor placeholder:text-[14px] outline-none`}
                    />
                    </div>
                    {/* {globalSearchQuery?.length > 0 && (
                    <img
                        src="/assets/close-icon.svg"
                        alt="close-icon"
                        className="cursor-pointer"
                        onClick={() => setGlobalSearchQuery("")}
                    />
                    )} */}
                    <div className="flex justify-center items-center mr-[0.5%] lg:mr-[0.2%] text-[15px] text-white w-[30%] bg-gradient-to-r from-[#1A67D8] to-[#0047AF] h-[48px] rounded-[48px] cursor-pointer"  onClick={handleSearchClick}>
                    Search
                    </div>
                    {globalSearchQuery?.length > 0 &&
                    productsBySearchQuery?.length > 0 && (
                        <div className="w-full h-[33vh] bg-whiteColor  border rounded-3xl shadow py-[3%] mt-1 absolute left-0 right-0 top-14 z-50 overflow-y-scroll scrollbar-hide">
                        {productsBySearchQuery?.map((item, index) => (
                            <div
                            className="w-full h-fit flex justify-between items-center border-b px-[2%] py-[1%] cursor-pointer"
                            key={index}
                            onClick={() => handleAddProductsToBeSearched(item)}
                            >
                            <span className="font-normal text-[0.8vw] text-textPrimaryColor">
                                {item}
                            </span>
                            </div>
                        ))}
                        </div>
                    )}
                </div>
                </div>
                
                {isSearched && productsByBrandAndQuery?.length > 0 && (
                    <div className="w-full h-fit px-[3%] lg:px-[10%] pb-[3%]">
                        <div className="w-full h-fit lg:px-[1%] mb-[3%] lg:mb-[1%]">
                            <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                                Results
                            </span>
                        </div>
                        <div className="w-full h-[75vh] grid grid-cols-1 lg:grid-cols-3 gap-x-0 gap-y-4 lg:gap-y-6 mx-auto justify-items-center mb-[3%] lg:mb-[1%] overflow-x-hidden overflow-y-scroll scrollbar-hide">
                            <Suspense
                                fallback={
                                    <div className="w-full h-fit flex justify-center items-center">
                                        <p className="font-normal text-[1vw] text-textSecondaryColor">
                                            Loading products...
                                        </p>
                                    </div>
                                }>
                                {productsByBrandAndQuery?.map((item, index) => (
                                    <ProductCard key={index} data={item} />
                                ))}
                            </Suspense>
                        </div>
                    </div>
                )}
                {!isSearched && (
                    <div className="w-full h-fit">
                        <div className="w-full h-fit flex flex-col lg:flex-row lg:justify-between items-start px-[5%] lg:px-[10%] my-[10%] lg:my-[3%]">
                            <div className="flex flex-col mb-[7.5%] lg:mb-0">
                                <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[5%]">
                                    Home collection Timings
                                </p>
                                <p className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                                    {aboutLabsData[formattedBrandName].timing}
                                </p>
                            </div>
                            <div className="flex flex-col mb-[7.5%] lg:mb-0">
                                <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[3%]">
                                    Collection Charges
                                </p>
                                <p className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                                    {aboutLabsData[formattedBrandName].charge}
                                </p>
                            </div>
                            <div className="flex flex-col mb-[7.5%] lg:mb-0">
                                <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[5%]">
                                    Products Available
                                </p>
                                <p className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                                    {aboutLabsData[formattedBrandName].products}
                                </p>
                            </div>
                            <div className="flex flex-col">
                                <p className="font-normal text-[4vw] lg:text-[1vw] text-textSecondaryColor mb-[5%]">
                                    Center Visit
                                </p>
                                <p className="font-medium text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                                    {aboutLabsData[formattedBrandName].center}
                                </p>
                            </div>
                        </div>
                        <div className="w-full h-fit bg-secondaryColor flex flex-col lg:flex-row lg:justify-between items-center lg:px-[10%] py-[7.5%] lg:py-[2%] space-y-[7.5%] lg:space-y-0 mb-[7.5%] lg:mb-[5%]">
                            {labPageData.map((item, index) => (
                                <div
                                    className="flex flex-col justify-center items-center space-y-[3%]"
                                    key={index}>
                                    <img
                                        src={item.icon}
                                        alt="icon"
                                        className="w-[33%]"
                                    />
                                    <span className="font-semibold text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                                        {item.title}
                                    </span>
                                </div>
                            ))}
                        </div>
                        <div className="w-full h-fit flex justify-center items-center px-[3%] lg:px-0">
                            <div
                                className={`w-full ${
                                    formattedBrandName === "Pathkind Labs"
                                        ? "lg:w-[25%]"
                                        : formattedBrandName ===
                                          "Agilus Diagnostics"
                                        ? "lg:w-[6%]"
                                        : "lg:w-[12.5%]"
                                } h-fit bg-[#E3E3E3] flex justify-between items-center border rounded-full`}>
                                {formattedBrandName === "Pathkind Labs" &&
                                    productTypePathkind?.map((item, index) => {
                                        return (
                                            <button
                                                key={index}
                                                className={`${
                                                    item.value ===
                                                    selectedProductType
                                                        ? "bg-primaryColor text-whiteColor rounded-full"
                                                        : "bg-[#E3E3E3] text-textSecondaryColor rounded-full"
                                                } px-[5%] py-[3%] lg:py-[2.5%] font-normal text-[3.5vw] lg:text-[1vw] whitespace-nowrap`}
                                                onClick={() =>
                                                    setSelectedProductType(
                                                        item.value
                                                    )
                                                }>
                                                {item.title}
                                            </button>
                                        );
                                    })}
                                {formattedBrandName === "Agilus Diagnostics" &&
                                    productTypeAgilus?.map((item, index) => {
                                        return (
                                            <button
                                                key={index}
                                                className={`${
                                                    item.value ===
                                                    selectedProductType
                                                        ? "lg:w-40 bg-primaryColor text-whiteColor rounded-full"
                                                        : "lg:w-40 bg-[#E3E3E3] text-textSecondaryColor rounded-full"
                                                } px-[7.5%] py-[3%] lg:py-[9%] font-normal w-full text-[3.5vw] lg:text-[1.1vw] whitespace-nowrap`}
                                                onClick={() =>
                                                    setSelectedProductType(
                                                        item.value
                                                    )
                                                }>
                                                {item.title}
                                            </button>
                                        );
                                    })}
                                {formattedBrandName !== "Pathkind Labs" &&
                                    formattedBrandName !==
                                        "Agilus Diagnostics" && formattedBrandName !==
                                        "Dr Lal PathLabs" &&
                                    productType?.map((item, index) => {
                                        return (
                                            <button
                                                key={index}
                                                className={`${
                                                    item.value ===
                                                    selectedProductType
                                                        ? "lg:w-40 bg-primaryColor text-whiteColor rounded-full"
                                                        : "lg:w-40 bg-[#E3E3E3] text-textSecondaryColor rounded-full"
                                                } px-[7.5%] py-[3%] lg:py-[5%] font-normal text-[3.5vw] lg:text-[1vw] whitespace-nowrap`}
                                                onClick={() =>
                                                    setSelectedProductType(
                                                        item.value
                                                    )
                                                }>
                                                {item.title}
                                            </button>
                                        );
                                    })}

                                {formattedBrandName === "Dr Lal PathLabs" &&
                                    productTypeDrLal?.map((item, index) => {
                                        return (
                                            <button
                                                key={index}
                                                className={`${
                                                    item.value ===
                                                    selectedProductType
                                                        ? "lg:w-40 bg-primaryColor text-whiteColor rounded-full"
                                                        : "lg:w-40 bg-[#E3E3E3] text-textSecondaryColor rounded-full"
                                                } px-[7.5%] py-[3%] lg:py-[5%] font-normal w-full text-[3.5vw] lg:text-[1.1vw] whitespace-nowrap`}
                                                onClick={() =>
                                                    setSelectedProductType(
                                                        item.value
                                                    )
                                                }>
                                                {item.title}
                                            </button>
                                        );
                                    })}
                            </div>
                        </div>
                        {selectedProductType === "package" ? (
                            <PackageProductComponent
                                title="Most Prescribed Packages"
                                products={brandPopularData}
                                isFilter={false}
                            />
                        ) : selectedProductType === "Radiology" ? (
                            <ProductComponent
                                title="Popular X-Rays and Scans"
                                products={radiologyPopularData}
                                isFilter={false}
                            />
                        ) : (
                            <ProductComponent
                                title="Most Prescribed Diagnostic Tests"
                                products={popularPathologyTestproducts}
                                isFilter={false}
                            />
                        )}
                    </div>
                )}
            </div>
        </UIWrapper>
    );
};

export default Labs;
